"use client";
import React from "react";
import { useLocale } from "next-intl";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "@mynaui/icons-react";
import { sendGTMEvent } from "@next/third-parties/google";
import { useRouter } from "next/navigation";

export default function HomePageCTAButton({ text, eventKey, title }) {
  const router = useRouter();
  const locale = useLocale();
  function handleButtonClick(eventKey, locale, title) {
    sendGTMEvent({ event: eventKey });
    router.push(`/${locale}/${title.toLowerCase()}`);
  }
  return (
    <Button
      onClick={() => handleButtonClick(eventKey, locale, title)}
      variant="explore"
      size="lg"
    >
      {text}
      <ArrowUpRight className="ml-2" style={{ width: 24, height: 24 }} />
    </Button>
  );
}
